import { motion } from "framer-motion";
import {
  LockKey,
  Warning,
  PuzzlePiece,
  Compass,
} from "@phosphor-icons/react";

const services = [
  {
    n: "01",
    icon: LockKey,
    title: "Account Access Issues",
    body: "If your account has been disabled or suspended, I help you understand the situation and work towards resolving it through the right channels.",
  },
  {
    n: "02",
    icon: Warning,
    title: "Platform Errors & Restrictions",
    body: "From unexpected limits to features not working properly — I help figure out what's going wrong and how to fix it.",
  },
  {
    n: "03",
    icon: PuzzlePiece,
    title: "Feature & Content Problems",
    body: "If something suddenly disappears or stops working on your account, I'll look into it and help restore normal functionality.",
  },
  {
    n: "04",
    icon: Compass,
    title: "General Guidance",
    body: "If you're unsure what's happening with your account or what to do next, I can guide you step by step.",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36"
    >
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-16">
        <div>
          <span className="font-code text-xs uppercase tracking-[0.2em] text-accent">
            [ 01 ] — What I help with
          </span>
          <h2 className="font-display font-bold tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl mt-5 max-w-2xl">
            Straightforward help. Real answers.
          </h2>
        </div>
        <p className="font-body text-muted-foreground max-w-sm">
          Every case is different. These are the situations I work with most —
          if yours isn&apos;t listed, reach out anyway.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-border">
        {services.map((s, i) => (
          <motion.div
            key={s.n}
            data-testid={`service-card-${s.n}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group relative border-r border-b border-border p-8 sm:p-12 hover:bg-card transition-colors duration-300"
          >
            <div className="absolute top-0 left-0 h-[2px] w-0 bg-accent group-hover:w-full transition-all duration-500" />
            <div className="flex items-start justify-between mb-10">
              <s.icon
                size={40}
                weight="duotone"
                className="text-foreground group-hover:text-accent transition-colors duration-300"
              />
              <span className="font-code text-sm text-muted-foreground">
                {s.n}
              </span>
            </div>
            <h3 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight mb-4">
              {s.title}
            </h3>
            <p className="font-body text-muted-foreground leading-relaxed max-w-md">
              {s.body}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Services;
